import { Action } from '@ngrx/store';
import { type } from '../../util';

import { Patient } from '../../shared/models/patient.model';

export const actionTypes = {
  SET_CURRENT_REASON: type('[Reasons] Set the current reason'),
  UNSET_CURRENT_REASON: type('[Reasons] Unset the current reason'),
  UPDATE_REASON_PREFERENCE: type('[Reasons] Update reason preference'),
  UPDATE_REASON_VISIT_CHOICE: type('[Reasons] Update reason visit choice'),
  UPDATE_REASON_PREFERRED_DATE: type('[Reasons] Update reason Preferred date'),
  UPDATE_REASON_START_DATE: type('[Reasons] Update reason start date'),
  UPDATE_ELIGIBLE_ACCOUNTS_IDS: type('[Reasons] Update eligible account ids'),
  UPDATE_CONSECUTIVE_DELAY: type('[Reasons] Update consecutive delay'),
  SET_REASONS: type('[Reasons] Set the reasons'),
  REMOVE_REASONS: type('[Reasons] Remove a reasons'),
  ADD_REASONS: type('[Reasons] Add a reason'),
  RESET_REASONS: type('[Reasons] Reset the reasons'),
  SET_SELECTED_PATIENTS: type('[Reasons] Set the selected patients'),
  RESET_SELECTED_PATIENTS: type('[Reasons] Reset the selected patients'),
};

export class SetCurrentReason implements Action {
  type = actionTypes.SET_CURRENT_REASON;

  constructor(public payload: any) { }
}

export class UnsetCurrentReason implements Action {
  type = actionTypes.UNSET_CURRENT_REASON;
}

export class UpdateReasonPreference implements Action {
  type = actionTypes.UPDATE_REASON_PREFERENCE;

  constructor(public payload: any) { }
}

export class UpdateReasonVisitChoice implements Action {
  type = actionTypes.UPDATE_REASON_VISIT_CHOICE;

  constructor(public payload: any) { }
}

export class UpdateReasonPreferredDate implements Action {
  type = actionTypes.UPDATE_REASON_PREFERRED_DATE;

  constructor(public payload: any) { }
}

export class UpdateReasonStartDate implements Action {
  type = actionTypes.UPDATE_REASON_START_DATE;

  constructor(public payload: any) { }
}

export class UpdateEligibleAccountsIds implements Action {
  type = actionTypes.UPDATE_ELIGIBLE_ACCOUNTS_IDS;

  constructor(public payload: number[]) { }
}

export class UpdateConsecutiveDelay implements Action {
  type = actionTypes.UPDATE_CONSECUTIVE_DELAY;

  constructor(public payload: number) { }
}

export class AddReasons implements Action {
  type = actionTypes.ADD_REASONS;

  constructor(public payload: any[]) { }
}

export class RemoveReasons implements Action {
  type = actionTypes.REMOVE_REASONS;

  constructor(public payload: any[]) { }
}

export class SetReasons implements Action {
  type = actionTypes.SET_REASONS;

  constructor(public payload: any[]) { }
}

export class SetSelectedPatients implements Action {
  type = actionTypes.SET_SELECTED_PATIENTS;

  constructor(public payload: any[]) { }
}

export class ResetSelectedPatients implements Action {
  type = actionTypes.RESET_SELECTED_PATIENTS;
}

export class ResetReasons implements Action {
  type = actionTypes.RESET_REASONS;
}

export type Actions
  = SetCurrentReason
  | UnsetCurrentReason
  | UpdateReasonPreference
  | UpdateReasonVisitChoice
  | UpdateReasonPreferredDate
  | UpdateReasonStartDate
  | UpdateEligibleAccountsIds
  | AddReasons
  | RemoveReasons
  | SetReasons
  | ResetReasons
  | SetSelectedPatients;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reasons.actions.ts